// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';

/**
 * Deletes an existing file from a purchase order.
 *
 * @param purchaseOrderKey - The key of the purchase order.
 * @param fileKey - The key of the file.
 */
export async function deletePurchaseOrderFile(
  purchaseOrderKey: string,
  fileKey: string
) {
  const path = `/v1/purchase-order/${purchaseOrderKey}/file/${fileKey}`;
  const response = await api.delete(path);

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'DeletePurchaseOrderFile',
    endpoint: path,
  });
}
